import { PlanningModuleProvider, usePlanningModule } from "contexts/app/planningData";
import LeaveRequestFormModal from "components/hr/display/LeaveRequestFormModal";
import { PlanningFilterMenu } from "./display/PlanningFilters";
import PlanningAccessDenied from "./display/PlanningAccessDenied";
import PlanningLoading from "./display/PlanningLoading";
import PlanningViewContent from "./display/PlanningViewContent";

export default function PlanningPage() {
  return (
    <PlanningModuleProvider>
      <PlanningPageContent />
    </PlanningModuleProvider>
  );
}

function PlanningPageContent() {
  const {
    canAccessPlanning,
    loading,
    periodTitle,
    viewMode,
    setViewMode,
    handlePrev,
    handleNext,
    handleToday,
    filterMenuProps,
    gridProps,
    leaveForm,
  } = usePlanningModule();

  if (!canAccessPlanning) return <PlanningAccessDenied />;
  if (loading) return <PlanningLoading />;

  return (
    <PlanningViewContent
      periodTitle={periodTitle}
      viewMode={viewMode}
      onPrev={handlePrev}
      onNext={handleNext}
      onToday={handleToday}
      onViewModeChange={setViewMode}
      filterSlot={<PlanningFilterMenu {...filterMenuProps} />}
      leaveModalSlot={
        leaveForm.canCreate ? (
          <LeaveRequestFormModal
            open={leaveForm.open}
            onClose={leaveForm.onClose}
            onSave={leaveForm.onSave}
            allowedTypeIds={leaveForm.allowedTypeIds}
            restrictTypeSelectionToAllowedOnly={leaveForm.restrictTypeSelection}
            initialDateKey={leaveForm.initialDateKey}
          />
        ) : null
      }
      gridProps={gridProps}
    />
  );
}
